import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    unselectableText: {
        textAlign: "center",
        ...webStyle({
            userSelect: "none"
        })
    },
    roleText: {
        textAlign: "center",
        ...webStyle({
            userSelect: "none"
        })
    },
    card: {
        alignItems: "center"
    },
    avatar: {
        borderRadius: 175,
        height: 350,
        width: 350
    },
    installPwaContainer: {
        width: "100%",
        maxWidth: 400
    },
    contentContainer: {
        width: "100%",
        maxWidth: 500
    },
    buttonContainer: {
        width: 200
    }
});
export default stylesheet;
